import type { SpaceDirection } from '../types/layout-operations'

const SPACE_BETWEEN_ICON_PATHS: Record<SpaceDirection, string> = {
  horizontal:
    'M10 1.3335L8 3.3335L6 1.3335M2.66667 5.3335H6C6.36819 5.3335 6.66667 5.63197 6.66667 6.00016V13.3335C6.66667 13.7017 6.36819 14.0002 6 14.0002H2.66667C2.29848 14.0002 2 13.7017 2 13.3335V6.00016C2 5.63197 2.29848 5.3335 2.66667 5.3335ZM10 5.3335H13.3333C13.7015 5.3335 14 5.63197 14 6.00016V13.3335C14 13.7017 13.7015 14.0002 13.3333 14.0002H10C9.63181 14.0002 9.33333 13.7017 9.33333 13.3335V6.00016C9.33333 5.63197 9.63181 5.3335 10 5.3335Z',
  vertical:
    'M1.33301 6L3.33301 8L1.33301 10M5.99967 2H13.333C13.7012 2 13.9997 2.29848 13.9997 2.66667V6C13.9997 6.36819 13.7012 6.66667 13.333 6.66667H5.99967C5.63148 6.66667 5.33301 6.36819 5.33301 6V2.66667C5.33301 2.29848 5.63148 2 5.99967 2ZM5.99967 9.33333H13.333C13.7012 9.33333 13.9997 9.63181 13.9997 10V13.3333C13.9997 13.7015 13.7012 14 13.333 14H5.99967C5.63148 14 5.33301 13.7015 5.33301 13.3333V10C5.33301 9.63181 5.63148 9.33333 5.99967 9.33333Z',
}

export function SpaceBetweenIcon({ direction }: { direction: SpaceDirection }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="h-4 w-4"
      aria-hidden="true"
    >
      <path
        d={SPACE_BETWEEN_ICON_PATHS[direction]}
        stroke="currentColor"
        strokeWidth="1.333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
